import React from "react";
import ProjectSelector from "../../components/project-selector";

const TakeOffLanding: React.FC = () => (
    <ProjectSelector dialogOpen={true} setDialogOpen={() => { /* Ignore */}}/>
)

export default TakeOffLanding;